import { useQueries, type UseQueryOptions } from "@tanstack/react-query";

import { useApiDeprecated } from "../../context";
import { type PaginatedResponse } from "../common";
import type { DoctorExpanded, DoctorsListOrder } from "./definitions";

type UseV1DoctorsListExpandedParams = {
  limit: number;
  city?: number;
  city_area?: number;
  service?: number[];
  clinic?: number;
  ordering?: DoctorsListOrder;
  lat?: number;
  lng?: number;
  age_from?: number | null;
  age_to?: number | null;
  age?: number | null;
  slot_date?: string;
  language?: string;
  insurance?: number;
  exclude?: number[];
  nearest_city_area?: number;
  locale: string;
  is_active?: boolean;
};

type UseV1DoctorsListExpandedParallelParams = {
  pages: { offset: number; seen: boolean }[];
} & UseV1DoctorsListExpandedParams;
type UseV1DoctorsListExpandedParallelResult = PaginatedResponse<
  DoctorExpanded[]
>;
type UseV1DoctorsListExpandedParallelOptions =
  UseQueryOptions<UseV1DoctorsListExpandedParallelResult>;

export const useV1DoctorsListExpandedParallel = (
  { pages, locale, ...params }: UseV1DoctorsListExpandedParallelParams,
  options?: Partial<UseV1DoctorsListExpandedParallelOptions>,
) => {
  const url = `/api/v1/doctors/`;
  const { cleanApi } = useApiDeprecated();

  return useQueries({
    queries: pages.map((page) => {
      return {
        enabled: page.seen,
        queryKey: [url, page.offset, params],
        queryFn: () => {
          return cleanApi(
            {
              url,
              method: "GET",
              params: {
                ...params,
                offset: page.offset,
                service: params.service?.join(","),
                expand: [
                  "clinic_branches",
                  "clinic_branches_",
                  "services",
                ].join(","),
                exclude: params.exclude?.join(","),
              },
              headers: {
                "Accept-Language": locale,
              },
            },
            {
              200: async (r) => r.data,
            },
          );
        },
        ...options,
      };
    }),
  });
};
